import { ActionButton } from './ui/ActionButton';
import React from 'react';

interface NmButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'neutral' | 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
}

/** Compatibility adapter: existing callers share the action-control implementation. */
export function NmButton({
  children,
  variant = 'neutral',
  type = 'submit',
  size = 'md',
  loading,
  icon,
  iconPosition = 'left',
  className = '',
  disabled,
  ...props
}: NmButtonProps) {
  const sizeClass = size === 'sm' ? 'nm-btn--sm' : size === 'lg' ? 'nm-btn--lg' : '';

  return (
    <ActionButton
      type={type}
      variant={variant === 'secondary' ? 'primary' : variant}
      size={size}
      loading={loading}
      icon={icon}
      iconPosition={iconPosition}
      className={`nm-btn nm-btn--${variant} ${sizeClass} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {children}
    </ActionButton>
  );
}
